import { useEffect, useState } from "react";
import { FaInstagram, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { LuFacebook, LuMessageCircle } from "react-icons/lu";
import { MdOutlineEmail } from "react-icons/md";
import { getFirestore, collection, doc, query, where, orderBy, onSnapshot, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function Footer() {
    const [revenda, setRevenda] = useState({});

    const navLinks = [
       
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
        const firestore = getFirestore(app);

        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setRevenda(docSnap.data());
            }
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

    return (
        <footer className="bg-secondary px-4 md:px-8 py-10">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <img
                        src="/logo-white.png"
                        alt="Ferrari Veículos"
                        width={200}
                        height={100}
                        className="mb-4"
                    />

                </div>

                <div>
                    <h4 className="text-display text-lg font-bold text-foreground mb-6">Links Rápidos</h4>
                    <nav>
                        <ul className="space-y-3">
                            {navLinks.map((link) => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        className="text-white hover:text-primary transition-colors"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href="/politica-de-privacidade" className="text-white hover:text-primary transition-colors">
                                    Política de Privacidade
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div>
                    <h4 className="text-display text-lg font-bold text-foreground mb-6">Contato</h4>

                    <div className="space-y-3 text-sm">
                        <div className="flex items-start gap-2">
                            <FaLocationDot className="w-5 h-5 text-primary mt-0.5" />
                            <p className="text-white">{revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}</p>
                        </div>

                        <div className="flex items-start gap-2">
                            <FaPhoneAlt className="w-5 h-5 text-primary" />
                            <p className="text-white">{retiraMascara(revenda.petelefone1)}</p>
                        </div>

                        <div className="flex items-start gap-2">
                            <LuMessageCircle className="w-5 h-5 text-primary" />
                            <p className="text-white">{retiraMascara(revenda.petelefone2)}</p>
                        </div>

                        <div className="flex items-start gap-2">
                            <MdOutlineEmail className="w-5 h-5 text-primary" />
                            <p className="text-white">{revenda.peemail}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/20 mt-10 pt-4 text-center text-xs text-white/80">
                © Copyright 2026 Pissarelli Automoveis | Todos os direitos reservados.
                <a className="ml-2 text-blue-500 hover:text-red-600 transition-colors" href="https://intermedioveiculos.com.br/">Intermédio Veículos Marketing Digital</a>
            </div>
        </footer>
    );
}
